/**
 * @flow
 * @relayHash 30ee274633ec48dd2f456244951f78fa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type GeneratePOsForOrdersMutationVariables = {||};
export type GeneratePOsForOrdersMutationResponse = {|
  +generatePOsForOrders: {|
    +purchaseOrders: $ReadOnlyArray<{|
      +node: {|
        +id: string,
        +poNumber: string,
        +vendor: ?{|
          +id: string,
          +name: string,
        |},
        +status: POStatus,
        +totalAmount: number,
      |}
    |}>,
    +itemsProcessed: number,
  |}
|};
export type GeneratePOsForOrdersMutation = {|
  variables: GeneratePOsForOrdersMutationVariables,
  response: GeneratePOsForOrdersMutationResponse,
|};
*/


/*
mutation GeneratePOsForOrdersMutation {
  generatePOsForOrders {
    purchaseOrders {
      node {
        id
        poNumber
        vendor {
          id
          name
        }
        status
        totalAmount
      }
    }
    itemsProcessed
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generatePOsForOrders",
    "storageKey": null,
    "args": null,
    "concreteType": "GeneratePOsForOrdersPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "purchaseOrders",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrder",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "poNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalAmount",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "itemsProcessed",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GeneratePOsForOrdersMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GeneratePOsForOrdersMutation",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GeneratePOsForOrdersMutation",
    "id": null,
    "text": "mutation GeneratePOsForOrdersMutation {\n  generatePOsForOrders {\n    purchaseOrders {\n      node {\n        id\n        poNumber\n        vendor {\n          id\n          name\n        }\n        status\n        totalAmount\n      }\n    }\n    itemsProcessed\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab779fbd9d453e49b8986348c3af7e2b';
module.exports = node;
